import axios from "../config/axios"


export const LlmModelRepository = {
  getAll: () => {
    return axios.get(`/api/llm-model/all`);
  },
  getPaged: (page = 0, size = 10) => {
    return axios.get(`/api/llm-model`, {params: {page, size}});
  },
  getMyModels: () => {
    return axios.get(`/api/llm-model/my`);
  },
  getPublicModels: () => {
    return axios.get(`/api/llm-model/public`);
  },
  getByOrganization: (organizationId) => {
    return axios.get(`/api/llm-model/organization/${organizationId}`);
  },
  getById: (id) => {
    return axios.get(`/api/llm-model/${id}`);
  },
  create: (model) => {
    return axios.post(`/api/llm-model`, model);
  },
  // apiKey cannot be changed after creation, the backend ignores it here
  edit: (id, model) => {
    return axios.put(`/api/llm-model/${id}`, model);
  },
  delete: (id) => {
    return axios.delete(`/api/llm-model/${id}`);
  },
}
